export function convertSize(l, vw) {
  return (l * (vw / 375));
}
